import { useSelector } from "react-redux";
import { selectCurrentUserFirstName, selectCurrentUserName } from "../features/auth/authSlice";

export const useGetUserInitial = (): string => {
    const currentLogUserName = useSelector(selectCurrentUserFirstName)

    return currentLogUserName?.trim().charAt(0).toUpperCase() || "";
}